import { MealDetailWithTitle } from './types';

export const mergeMealDetails = (mealDetails: MealDetailWithTitle[]) => {
  return mealDetails.reduce((acc, meal) => {
    const macros = meal.macros;
    const micros = meal.micros;
    const food = meal.food;
    const source = meal.source;

    if (macros) {
      const mergedMacros = Object.entries(macros).reduce(
        (macro_acc, [key, value]) => {
          macro_acc[key] = (macro_acc[key] || 0) + value;
          return macro_acc;
        },
        {} as Record<string, number>
      );
      acc.macros = mergedMacros;
    }

    if (micros) {
      const mergedMicros = Object.entries(micros).reduce(
        (micro_acc, [key, value]) => {
          micro_acc[key] = (micro_acc[key] || 0) + value;
          return micro_acc;
        },
        {} as Record<string, number>
      );
      acc.micros = mergedMicros;
    }

    if (food) {
      const newFood = `${food.name} x ${food.amount}`;
      acc.title = acc.title ? `${acc.title}, ${newFood}` : newFood;
    }

    if (source) {
      acc.source = source;
    }

    return acc;
  }, {} as MealDetailWithTitle);
};

// Emoji mapping for nutritional components
export const getNutritionEmoji = (macro: string): string => {
  const emojiMap: Record<string, string> = {
    sodium: '🧂',
    fat: '🧈',
    protein: '🍗',
    sugar: '🍭',
    calories: '🔥',
    cholesterol: '🧬',
    saturatedFat: '🧀',
    carbohydrates: '🍞',
    fiber: '🌾',
    potassium: '🥑',
    calcium: '🥛',
    iron: '🔩',
    vitaminC: '🍊',
    vitaminD: '☀️',
    vitaminB12: '💊',
  };
  return emojiMap[macro] || '📊';
};
